import { render, staticRenderFns } from "./planConfig.vue?vue&type=template&id=bd15cf8c&scoped=true&"
import script from "./planConfig.vue?vue&type=script&lang=js&"
export * from "./planConfig.vue?vue&type=script&lang=js&"
import style0 from "./planConfig.vue?vue&type=style&index=0&id=bd15cf8c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd15cf8c",
  null
  
)

export default component.exports